import VeoliaLogo from "./veolia.png";

export { VeoliaLogo };
